import { SpecialSymbolGroup } from './special-symbol-group.model';
import { Line } from './line.model';
import { ReelWinPosition } from './reel-position.model';
import { FreeSpinsInfoEvent, FreeSpinsInfo } from './free-spins-info.model';
import { CollapseInfo } from './collapse-info.model';
import { ErrorLevel } from './error-level.model';
import { FreeSpinReBuyInfoResponse } from './free-spin-rebuy-info.model';
import { BonusResponse } from './bonus.model';
import { GambleInfo } from './gamble.model';

export class SpinResponse {
  public aboveReels: number[][] = [];
  public belowReels: number[][] = [];
  public viewReels: number[][] = [];
  public winLines: Line[] = [];
  public winPositions: ReelWinPosition[] = [];
  public specialSymbolGroups: SpecialSymbolGroup[] = [];
  public additionalData: any;
  public totalWin: number;
  public totalLost: number;

  public freeSpinsInfo: FreeSpinsInfo | null = null;
  public reSpinsInfo: FreeSpinsInfo | null = null;
  public collapseInfo: CollapseInfo | null = null;
  public bonusInfo: BonusResponse | null = null;
  public gambleInfo: GambleInfo | null = null;

  public scatterInfo: BonusResponse | null = null;

  public get isBonus(): boolean {
    return !!this.bonusInfo;
  }

  public get isScatter(): boolean {
    return !!this.scatterInfo;
  }

  public get isFreeSpins(): boolean {
    return !!this.freeSpinsInfo;
  }

  public get isFreeSpinsActive(): boolean {
    return (
      !!this.freeSpinsInfo && this.freeSpinsInfo.event !== FreeSpinsInfoEvent.FreeSpinsFinished
    );
  }

  public isRespin = false;
  public isFakeResponse = false;
  public bigWinName: string;
  public errorLevel: ErrorLevel;
  public errorMessage: string;
  public freeSpinReBuyInfo: FreeSpinReBuyInfoResponse;

  public get currentWinLines(): Line[] {
    return this.collapseInfo && this.collapseInfo.collapsingCounter > 0
      ? this.collapseInfo.groups[this.collapseInfo?.collapsingCounter - 1]?.winLines
      : this.winLines;
  }

  public get currentWinPositions(): ReelWinPosition[] {
    return this.collapseInfo && this.collapseInfo.collapsingCounter > 0
      ? this.collapseInfo.groups[this.collapseInfo?.collapsingCounter - 1]?.winPositions
      : this.winPositions;
  }

  /** @deprecated do not mutate object */
  public clearWinLines(): void {
    this.winLines.length = 0;
  }

  /** @deprecated do not mutate object */
  public clearWinPositions(): void {
    this.winPositions.length = 0;
  }

  public configuredBets: Record<string, Record<string, Record<number, number[]>>>;
  public spinId: string | null = null;

  public toString(): string {
    return JSON.stringify(this);
  }
}
